<div class="tw:w-full tw:max-w-7xl tw:mx-auto tw:px-4 tw:mt-24">
  <div class="tw:flex tw:flex-wrap error-page tw:items-center">
    <div class="error-page-content tw:w-full tw:md:w-1/2">
      <h1 i18n>An error has occured</h1>
      <p i18n>
        We're sorry, an unexpected error has occurred and it has been logged. We will try to fix it as soon as possible.
      </p>
      <button class="ga-button ga-button--primary" routerLink="overview" i18n>Back to overview</button>
    </div>
    <div class="error-page-image tw:w-full tw:md:w-1/2 tw:h-[384px]">
      <div class="tw:w-[384px] tw:h-[384px] error-component-image"> </div>
    </div>
  </div>
</div>
